<template>
  <Dialog :open="open" @update:open="emit('update:open', $event)">
    <DialogScrollContent size="xl">
      <DialogHeader>
        <DialogTitle>
          {{ $t("Select a registration") }}
        </DialogTitle>
      </DialogHeader>
      <RegistrationIndex
        :base-filters="baseFilters"
        :available-filters="availableFilters"
        :add-url="addUrl"
        @change-registration="emit('select', $event)"
      >
      </RegistrationIndex>
    </DialogScrollContent>
  </Dialog>
</template>

<script setup>
import RegistrationIndex from "@/components/registration/RegistrationIndex.vue";
import { Dialog, DialogScrollContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

defineProps({
  open: {
    type: Boolean,
    default: false
  },
  baseFilters: {
    type: Object,
    default: () => ({})
  },
  availableFilters: {
    type: Array,
    default: () => []
  },
  addUrl: {
    type: String,
    default: null
  }
});

const emit = defineEmits(["update:open", "select"]);
</script>
